import Cookie from 'js-cookie';
import moment from 'moment';
import jwtDecode from 'jwt-decode';

const jwt = Cookie.get('token') || '';

const checkLoginStatus = (payload) => {
	const pageReferer = payload?.isRedirect ? window?.location?.href : '';

	const token = payload?.authorization || jwt;

	if (token) {
		let decod = null;
		try {
			decod = jwtDecode(token);
		} catch {
			decod = null;
		}
		const isValid = moment(decod?.iat || 0).isAfter(Date.now());
		if (!isValid) {
			payload?.isRedirect &&
				(window.location.href =
					payload.urlRedirect ||
					`${process.env.NEXT_PUBLIC_SSO_URL || ''}?url=${pageReferer}`);
			return false;
		}
		return true;
	}
	payload?.isRedirect &&
		(window.location.href =
			payload.urlRedirect ||
			`${process.env.NEXT_PUBLIC_SSO_URL || ''}?url=${pageReferer}`);
	return false;
};
export default checkLoginStatus;
